
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { ChipMenuMixin } from '../chip-menu-mixin'
import { GoodRoadMixin } from './good-road-mixin'
import DGoodRoadItem from './d-good-road-item.vue'

@Options({
    components: {
        DGoodRoadItem
    }
})
export default class DGoodRoadPanel extends Mixins(
    GoodRoadMixin,
    ChipMenuMixin
) {}
